<template>
  <div class='core_business_component'>
    <div class="business_content_wrap total-width">
      <div class="business_title">核心业务</div>
      <div class="business_btn_tab">
        <div class="tab_item brs" :class="{'active_tab': activeTab === index}" v-for="(item, index) in tabsData" :key="item" @click="activeTab = index">{{ item }}</div>
      </div>
      <template v-if="activeTab !== 1">
        <div  class="business_main" v-for="(item) in mainData" :key="item.id" v-show="activeTab === item.id">
          <div class="line_item">{{ item.line1 }}</div>
          <div v-if="item.line2" class="line_item">{{ item.line2 }}</div>
          <div v-if="item.line3" class="line_item">{{ item.line3 }}</div>
        </div>
      </template>
      <div class="business_main" v-if="activeTab === 1">
        <div class="line_item">
          专升本培训是集团主营项目之一，专升本培训业务的超强实力也是库课科技集团核心竞争力的充分体现，旗下两大专升本品牌均属于行业领先地位。其中“库课”荣获统招专升本培训（连续2年）通过率第一市场认证
          <el-tooltip effect="dark" popper-class="toolTip_content" :content="upgradeToolTipsContent1" placement="top">
            <img class="inline-block mb-[4px]" src="../../../assets/images/common/question_tip.svg" alt="问号">
          </el-tooltip>
          “天一专升本”以深耕河南线下培训为主，荣获河南统招专升本培训（连续2年）通过率第一市场认证 
          <el-tooltip effect="dark" popper-class="toolTip_content" :content="upgradeToolTipsContent2" placement="top">
            <img class="inline-block mb-[4px]" src="../../../assets/images/common/question_tip.svg" alt="问号">
          </el-tooltip>
        </div>
      </div>

      <!-- 图书出版 -->
      <div class="business_analysis">
        <div v-show="activeTab === 0" class="relative">
          <img class="mt-[32px] mb-[60px]"  src="../../../assets/images/products/book_analysis.png" alt="">
          <el-tooltip effect="dark" popper-class="toolTip_content" :content="bookToolTipsContent" placement="top">
            <img class="absolute top-[75%] left-[13.5%]" src="../../../assets/images/common/question_tip.svg" alt="问号">
          </el-tooltip>
        </div>
        <div class="upgrade_analysis" v-show="activeTab === 1">
          <div class="upgrade_item upgrade_left">
            <div class="title">事业定位</div>
            <img class="w-[256px] h-[120px]" src="../../../assets/images/products/upgrade_left.png" alt="">
          </div>
          
          <div class="upgrade_item upgrade_center">
            <div class="title">核心业务</div>
            <div class="flex items-center">
              <a href="https://www.kuke99.com" target="_blank"><img width="155" src="../../../assets/images/products/upgrade_center_icon1.png" alt=""></a>
              <div class="vertical_line"></div>
              <a href="https://www.kuke99.cn/#/network" target="_blank"><img width="155" src="../../../assets/images/products/upgrade_center_icon2.png" alt=""></a>
            </div>
          </div>

          <div class="upgrade_item upgrade_right">
            <div class="title">重点聚焦</div>
            <div class="item_line">
              <img width="24" class="mr-[12px]" src="../../../assets/images/products/right_icon.png" alt="">
              聚焦重点市场
            </div>
            <div class="item_line">
              <img class="mr-[12px]" width="24" src="../../../assets/images/products/right_icon.png" alt="">
              聚焦核心产品
            </div>
            <div class="item_line">
              <img class="mr-[12px]" width="24"  src="../../../assets/images/products/right_icon.png" alt="">
              聚焦铁军团队
            </div>
          </div>
        </div>
        <img v-show="activeTab === 2" width="488" class="mt-[60px]" src="../../../assets/images/products/public_office_analysis.png" alt="">

        <div v-show="activeTab === 0" class="flex">
          <div v-for="item in bookSortData" :key="item.id" class="book_sort">
            <div class="text-[#333] text-[20px] pb-[23px]">{{ item.title }}</div>
            <div class="flex">
              <div class="flex mr-[20px] items-center" v-for="i in item.list" :key="i">
                <img class="mr-[4px]" width="24"  src="../../../assets/images/products/right_icon.png" alt="对号">
                <div class="text-[#333] text-[14px] flex-shrink-0">{{ i }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Business',
  data() {
    return {
      tabsData: ['图书出版','专升本培训','公职培训'],
      activeTab: 0,
      mainData: [
        {
          id: 0,
          line1: '出版传媒事业部成立于2007年，自成立以来，事业部始终坚守“为天下学子成就美好人生”的企业使命，深耕图书研发与课程开发领域，以学员为中心，以产品为核心，引领知识传播新风尚，快速发展成为集团主营业务之一。',
          line2: '出版传媒事业部正加速迈入智能融合的新时代，将AI技术深度融入出版链条的每一个环节，全力构建集“精品内容、高效服务、趣味互动”于一体的智慧出版新生态。我们将为广大学子量身定制个性化、智能化的学习方案，以科技之光点亮求知之路，携手每一位追梦人，扬帆启航，共绘未来蓝图，为天下学子成就美好人生！'
        },
        {
          id: 2,
          line1: '公职项目成立于2011年。自成立以来，事业部秉承积极促进毕业生高质量充分就业的理念，在公务员招录、事业单人员招录、教师招录、三支一扶人员招录等领域深耕笃行，助力数十万名学子成功就业。',
          line2: '公职项目重视高质量智力产品体系的研究，自主研发了公务员、事业单位、教师招聘、三支一扶四大领域的教材、教辅、线上题库等核心产品。除此以外，还拥有各学科专职教师200余人，合作外部专家教授1000余名，各学科周边教研产品1000余套。',
          line3: '公职项目始终秉持“为天下学子成就美好人生”的企业使命，用“好课程、好师资、好产品、好效果”为学子的入编就业保驾护航。'
        }
      ],
      bookSortData: [
        {
          title: '学历提升类图书',
          list: ['专升本','中职生','普通高考','考研']
        },
        {
          title: '考证类图书',
          list: ['教师资格','社会工作者']
        },
        {
          title: '考编类图书',
          list: ['事业单位','三支一扶','公务员','教师招聘']
        },
      ],
      bookToolTipsContent: '数据来源：尚普咨询集团，覆盖全渠道市场，通过专家、企业及终端渠道调研，对比全国（不含港澳台）范围内各品牌统招专升本图书销售情况（以册计），得出：库课，统招专升本图书全国销量第一，统计时间：2023年1月1日至2023年12月31日，于2024年11月完成调研。',
      upgradeToolTipsContent1: '数据来源：尚普咨询集团，覆盖全国31个省、直辖市及自治区全渠道市场，通过专家、企业及终端渠道调研，对比全国（不含港澳台）范围内各品牌统招专升本培训情况，得出：库课，统招专升本培训（连续2年）通过率第一。统计时间：2023至2024学年，于2024年11月完成调研。',
      upgradeToolTipsContent2: '数据来源：尚普咨询集团，覆盖全渠道市场，通过专家、企业及终端渠道调研，对比河南省范围内各品牌统招专升本培训情况，得出：天一专升本，河南统招专升本培训（连续2年）通过率第一。统计时间：2023至2024学年，于2024年11月完成调研。',
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {

  },
}
</script>

<style>
.toolTip_content {
  width: 276px;
  font-size: 12px;
  line-height: 20px;
}
.brs {
  border-radius: 4px;
}
</style>

<style lang='less' scoped>
.core_business_component{
  margin: 0 auto;
  height: 875px;
  background: url('../../../assets/images/products/bg_core_business.png') no-repeat 100% / cover ;
  color:#111;
  .business_content_wrap {
    width: 1400px;
    margin: 0 auto;
    padding: 80px 0px;
  }
  .business_title {
    font-weight: 500;
    font-size: 40px;
    padding-bottom: 60px;
  }
  .business_btn_tab {
    display: flex;
    .tab_item {
      width: 144px;
      height: 50px;
      line-height: 50px;
      font-weight: 500;
      text-align: center;
      margin-right: 20px;
      background: #fff;
    }
    .active_tab {
      color: #fff;
      background: #e60020;
      border-radius: 4px;
    }
  }
  .business_main {
    padding-top: 40px;
    .line_item {
      font-size: 16px;
      line-height: 28px;
      font-family: PingFang SC, PingFang SC;
      width: 950px;
      &:not(:last-child) {
        padding-bottom: 20px;
      }
    }
  }

  .business_analysis {
    .upgrade_analysis {
      display: flex;
      margin-top: 16px;
      .upgrade_item {
        width: 466px;
        height: 383px;
        background: rgba(255,255,255,0.4);
        border-radius: 8px;
        border: 1px solid #FFFFFF;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 60px;
        margin-right: 20px;
        .title {
          color: #111;
          font-size: 28px;
          margin-bottom: 50px;
          font-weight: bold;
        }
        .vertical_line {
          height: 76px;
          width: 1px;
          background: #E60020;
          margin: 0 21px;
        }
        .item_line {
          display: flex;
          align-items: center;
          font-size: 24px;
          margin-bottom: 25px;
        }
      }
    }
    .book_sort {
      background: rgba(255,255,255,0.4);
      border-radius: 8px;
      border: 1px solid #FFFFFF;
      width: 466px;
      height: 155px;
      padding-left: 20px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      &:not(:last-child) {
        margin-right: 20px;
      }
    }
  }
}
</style>